import { render, staticRenderFns } from "./ImportDataTable.vue?vue&type=template&id=11e0d9d4&scoped=true&"
import script from "./ImportDataTable.vue?vue&type=script&lang=js&"
export * from "./ImportDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e0d9d4",
  null
  
)

export default component.exports